/**
 * Where a call or form entry lives in the app.
 *
 * One definition, because every surface that shows an intake — the quick view,
 * the linked-records list, the review dialog, the dashboard feeds — has to send
 * the user to the same place.
 */

import type { IntakeItem } from './leadloop-api';

export function intakeRecordRoute(
  sourceType: IntakeItem['sourceType'],
  sourceId: string,
): string {
  return sourceType === 'call'
    ? `/ai-systems/voice-agents?call=${encodeURIComponent(sourceId)}`
    : `/forms-feed?entry=${encodeURIComponent(sourceId)}`;
}

/** What to call the record in a button or a sentence. */
export function intakeRecordNoun(sourceType: IntakeItem['sourceType']): string {
  return sourceType === 'call' ? 'call' : 'form entry';
}
